// thirdparty.js
// This script loads a series of app scripts and is required for various functionality on the site.
(() => {
    const loadCustomScripts = () => {
        window.custom_scripts.forEach(script => {
            let s = document.createElement('script');
            s.setAttribute('src', script);
            document.head.insertAdjacentElement("beforeend", s);
        });
    };

    const loadScripts = () => {
        loadCustomScripts();
    };
    document.addEventListener('DOMContentLoaded', loadScripts, false);
})();
